import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const ownerList = createSlice({
  name: "ownerList",
  initialState,
  reducers: {
    addOwnerList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { addOwnerList } = ownerList.actions;
export default ownerList.reducer;
